import { Injectable, Injector } from '@angular/core';

import { AuthDetailsStore, CustomHttpClientService, PaymentsAuthenticationService, PaymentsCustomApiService } from '@payments/common-utils';

@Injectable({
    providedIn: 'root',
})
export class QdApiService extends PaymentsCustomApiService {
    constructor(
        customHttpClientService: CustomHttpClientService,
        authService: PaymentsAuthenticationService,
        injector: Injector,
        authDetailsStore: AuthDetailsStore,
    ) {
        super(customHttpClientService, authService, injector, authDetailsStore);
    }
}
